import React from 'react'
import MainPreloader from '@Components/Preloaders/MainPreloader'
import TransparentPreloader from '@Components/Preloaders/TransparentPreloader'

const Preloaders = () => (
    <>
        <MainPreloader />
        <TransparentPreloader />
    </>
)

export default Preloaders
